import { Component, OnInit, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../core/environment';

interface SettingsSummary {
  sports: number;
  batches: number;
  feePlans: number;
  paymentModes: number;
  staffDesignations: number;
  guestRates: number;
}

@Component({
  selector: 'app-settings',
  standalone: true,
  template: `
    <div class="ops-page">
      <div class="ops-hero settings-hero">
        <div><span>Configuration</span><h2>Settings</h2><p>Academy setup status, master data readiness and future integration switches.</p></div>
        <button type="button" (click)="load()">Refresh Settings</button>
      </div>

      <section class="settings-grid">
        @for (item of settingCards(); track item.label) {
          <article class="ops-card setting-card">
            <span>{{ item.label }}</span>
            <strong>{{ item.value }}</strong>
            <p>{{ item.note }}</p>
          </article>
        }
      </section>

      <section class="ops-grid">
        <article class="ops-card">
          <div class="card-title"><div><h3>Operational Preferences</h3><p>Future-ready toggles for academy workflows.</p></div><span>Ready</span></div>
          <div class="settings-list">
            <label><input type="checkbox" checked> Enable QR based in-time and out-time tracking</label>
            <label><input type="checkbox" checked> Block scan when membership is expired</label>
            <label><input type="checkbox" checked> Show fee due warning during entry</label>
            <label><input type="checkbox"> Enable SMS reminders</label>
            <label><input type="checkbox"> Enable WhatsApp reminders</label>
          </div>
        </article>

        <article class="ops-card">
          <div class="card-title"><div><h3>Academy Profile</h3><p>Displayed across receipts and admin screens.</p></div><span>Local</span></div>
          <div class="profile-preview">
            <strong>Elite Sports Academy</strong>
            <span>Multi-sport training, guest play and summer camp management</span>
            <p>Receipt prefix: RCP | Student prefix: STU | Staff prefix: STF | Guest prefix: GST</p>
          </div>
        </article>
      </section>
    </div>
  `
})
export class SettingsComponent implements OnInit {
  private readonly http = inject(HttpClient);
  readonly summary = signal<SettingsSummary | null>(null);

  ngOnInit(): void { this.load(); }

  load(): void {
    this.http.get<SettingsSummary>(`${environment.apiUrl}/settings/summary`).subscribe((summary) => this.summary.set(summary));
  }

  settingCards(): { label: string; value: number | string; note: string }[] {
    const data = this.summary();
    return [
      { label: 'Sports', value: data?.sports ?? '-', note: 'Active sport master records' },
      { label: 'Batches', value: data?.batches ?? '-', note: 'Class timing configurations' },
      { label: 'Fee Plans', value: data?.feePlans ?? '-', note: 'Monthly and program pricing' },
      { label: 'Payment Modes', value: data?.paymentModes ?? '-', note: 'Cash, UPI, card and bank' },
      { label: 'Designations', value: data?.staffDesignations ?? '-', note: 'Staff role setup' },
      { label: 'Guest Rates', value: data?.guestRates ?? '-', note: 'Hourly play pricing' }
    ];
  }
}

